var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAr = function SvgAr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ar_svg__a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338af3",
    d: "M0 0h512v144.7L488 256l24 111.3V512H0V367.3L26 256 0 144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M0 144.7h512v222.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "m332.4 256-31.2 14.7 16.7 30.3-34-6.5-4.2 34.3-23.7-25.2-23.6 25.2-4.3-34.3-34 6.5 16.6-30.3-31.2-14.7 31.3-14.7L194 211l34 6.5 4.3-34.3 23.6 25.2 23.6-25.2 4.4 34.3 34-6.5-16.7 30.3z"
  }))));
};
export default SvgAr;